import { BreastTomosynthesisImageStorage } from './Viewer/SOPClasses';
import { Stack } from './ViewportsConfigurations/types';

export const LOADING_PRIORITIES = Object.freeze({
  ACTIVE: 0,
  LINKED: 5,
  HANGED: 20,
  UNHANGED: 1000,
  UNHANGED_LOWER_PRIORITY: 10000,
  PREFETCHING: 20000,
});

export type LoadingPriorities = typeof LOADING_PRIORITIES;

export const getUnhungPriority = (stack: Stack): number => {
  if (
    stack &&
    'frames' in stack &&
    stack.frames?.some((frame) => frame?.sopClassUID === BreastTomosynthesisImageStorage)
  ) {
    return LOADING_PRIORITIES.UNHANGED_LOWER_PRIORITY;
  }

  return LOADING_PRIORITIES.UNHANGED;
};
